import { stringifyUrl } from "query-string";
import { PageQuery } from "../users/UsersApi";
import { MailsLoader } from "./MailsLoader";
import { CreateMailTaskRequest, MailsTasksResponse } from "../typings/Mails";

export type MailsTasksQuery = {
  includes?: MailsTasksIncludes[];
  with_trashed?: "0" | "1";
} & Partial<PageQuery>;

export type MailsTasksIncludes = "mails";

export class MailsTasksApi {
  public static getMailsTasks(query: MailsTasksQuery = {}) {
    const url = stringifyUrl({ url: "/mails_tasks", query }, { arrayFormat: "comma" });
    return MailsLoader.get<MailsTasksResponse>({ url });
  }

  public static getMailTask(id: string, query: MailsTasksQuery = {}) {
    const url = stringifyUrl({ url: `/mails_tasks/${id}`, query }, { arrayFormat: "comma" });
    return MailsLoader.get<MailsTasksResponse>({ url });
  }

  public static createMailTask(data: CreateMailTaskRequest, query: MailsTasksQuery = {}) {
    const url = stringifyUrl({ url: "/mails_tasks", query }, { arrayFormat: "comma" });
    return MailsLoader.post<MailsTasksResponse>({ url, data });
  }
}
